import { Badge } from 'design-system';

export interface ITwoFacAuthBadgeCell {
  isTwoFacAuthActive: boolean;
}

export const TwoFacAuthBadge = ({ isTwoFacAuthActive }: ITwoFacAuthBadgeCell) => {
  if (!isTwoFacAuthActive) {
    return (
      <Badge colorScheme='red' py='sm' px='sm' rounded={'full'}>
        Inactive
      </Badge>
    );
  }

  return (
    <Badge colorScheme='green' py='sm' px='sm' rounded={'full'}>
      Active
    </Badge>
  );
};
